export default "/images/dd50bf5b34a7804f4540d04c55c8a8f5.avif";